export default __webpack_public_path__ + "static/media/deposit-icon.fc7ddf87.webp";